import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { updateTask, removeTask, listTasks } from "../../api/todo";

const ListItem = ({ task, setTasks }) => {
  const updateTaskHandler = () => {
    updateTask(task._id, !task.isCompleted);
    listTasks((data) => {
      setTasks(data);
    });
  };

  const removeTaskHandler = () => {
    removeTask(task._id);
    listTasks((data) => {
      setTasks(data);
    });
  };

  return (
    <div className="list-item">
      <div
        className={`todo-item ${task.isCompleted ? "completed" : ""}`}
        onClick={updateTaskHandler}
      >
        {task.text}
      </div>
      <div className="delete-icon">
        <FontAwesomeIcon
          className="delete"
          icon={faTrash}
          color="#D25836"
          size="xs"
          onClick={removeTaskHandler}
        />
      </div>
    </div>
  );
};

export default ListItem;
